module.exports = __webpack_public_path__ + "assets/img/Type E (80).4258e691.jpg";